import $ from 'jquery/src/jquery';

export default () => {
    // const nodeSelectors = {
    //     sectionContainer: '[js-form="section-container"]',
    // }

    function init() {
        if (!document.querySelector('.wpcf7')) {
            return
        }

        let wpcf7Elm = document.querySelectorAll( '.wpcf7' );

        wpcf7Elm.forEach(function (form) {
            // console.log(form)
            $(form).find('.gl-form__control--submit').append('<div class="gl-loader-holder"><div class="gl-loader-holder__loader"></div></div>')
        })

        // document.addEventListener('wpcf7mailsent', function(event) {
        //     $('form select').val('').trigger('change')
        // }, false)

        // When email is sent
        document.addEventListener( 'wpcf7mailsent', function( event ) {
            // Hide form and show thank you message
            let formId = event.detail.unitTag
            let formEl = $('#' + formId)
            let parent = $('body')
            let contentToHide = parent.find('.contact-form-content-to-replace-after-submission')
            contentToHide.slideUp()

            let customMessageHolder = parent.find('.custom-form-thank-you-message')

            if( !customMessageHolder.length ) {
                // If custom hidden message on page doesn't exist show contact form 7 message
                // parent.append('<div class="form-thank-you-message" style="display: none">' + event.detail.apiResponse.message + '</div>')
                //
                // formEl.slideUp(function () {
                //     setTimeout(function () {
                //         let message = parent.find('.form-thank-you-message')
                //         message.slideDown()
                //         formEl.remove()
                //     }, 100)
                // });
            } else {
                // If custom hidden message on page exists show it
                formEl.slideUp(function () {
                    setTimeout(function () {
                        customMessageHolder.slideDown(function (){
                            let target = customMessageHolder.offset().top - 200
                            $("html, body").animate({ scrollTop: target }, 350);
                        })
                        formEl.remove()
                    }, 100)
                });
            }

            $('body').addClass('form-message-is-sent')
        })
    }

    return Object.freeze({
        init,
    })
}